<p-breadcrumb
  [model]="[{ label: 'Colaboradores', routerLink: ['/employees'] }]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Colaboradores</h5>
      <p>Gerencie os colaboradores que utilizam o sistema</p>
    </div>
    <p-button label="Novo Colaborador" routerLink="/employees/create" rounded />
  </div>
</p-toolbar>

<p-table
  #table
  [value]="employees()"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
>
  <ng-template #caption>
    <div class="flex gap-5 items-center">
      <p>Filtrar por:</p>
      <div class="w-100">
        <input
          pInputText
          type="text"
          id="fullNameFilter"
          class="block"
          [(ngModel)]="fullNameFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Nome completo"
          fluid
        />
      </div>
      <div class="w-100">
        <input
          pInputText
          type="text"
          id="emailFilter"
          class="block"
          [(ngModel)]="emailFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="E-mail"
          fluid
        />
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <th>Nome completo</th>
      <th>E-mail</th>
      <th>Último acesso</th>
      <th>Status</th>
      <th>Ações</th>
    </tr>
  </ng-template>

  <ng-template #body let-item>
    <tr>
      <td>{{ item.fullName || item.firstName + " " + item.lastName }}</td>
      <td>{{ item.email }}</td>
      <td>
        {{
          item.lastLoginAt ? (item.lastLoginAt | date: "dd/MM/yyyy HH:mm") : "-"
        }}
      </td>
      <td>
        <app-tag-status
          [status]="item.status"
          [text]="getStatusDescription(item.status)"
          class="px-3!"
        />
      </td>
      <td>
        <p-button
          icon="ph ph-pencil"
          class="mr-2"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/employees/update/' + item.id"
        ></p-button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">
        <p class="text-center">Nenhum registro encontrado!</p>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast />
